import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkIcon, Share2Icon, QrCodeIcon, UsersIcon } from 'lucide-react';
import Button from '../../components/ui/Button';
import { useOrder } from '../../context/OrderContext';
const GroupOrderShare: React.FC = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    getCurrentGroupOrder
  } = useOrder();
  const [copied, setCopied] = useState(false);
  const [participants, setParticipants] = useState<{
    id: string;
    name: string;
  }[]>([{
    id: 'user-123',
    name: 'Terry Crews (You)'
  }]);
  const shareUrl = `https://justcheetah.com/join/${id}`;
  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const handleContinue = () => {
    navigate('/food');
  };
  // Simulate real-time updates
  useEffect(() => {
    const timer = setTimeout(() => {
      setParticipants(prev => [...prev, {
        id: `user-${Date.now()}`,
        name: 'Jane Smith'
      }]);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="max-w-3xl mx-auto px-4" data-id="element-591">
      <div className="bg-white rounded-lg shadow-md p-4 sm:p-6" data-id="element-592">
        <div className="flex items-center mb-4 sm:mb-6" data-id="element-593">
          <div className="w-10 h-10 bg-[#E84118] bg-opacity-10 rounded-full flex items-center justify-center mr-3 sm:mr-4" data-id="element-594">
            <Share2Icon size={20} className="text-[#E84118]" data-id="element-595" />
          </div>
          <h1 className="text-lg sm:text-xl font-bold" data-id="element-596">Share Group Order</h1>
        </div>
        <div className="text-center mb-6 sm:mb-8" data-id="element-597">
          <div className="bg-gray-50 rounded-lg p-4 sm:p-8 mb-4 sm:mb-6" data-id="element-598">
            <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto bg-white p-2 rounded-lg shadow-md mb-3 sm:mb-4" data-id="element-599">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center" data-id="element-600">
                <QrCodeIcon size={60} className="text-gray-700" data-id="element-601" />
              </div>
            </div>
            <h2 className="text-base sm:text-lg font-medium mb-2" data-id="element-602">
              Group Order: {id}
            </h2>
            <p className="text-gray-600 text-sm mb-4" data-id="element-603">
              Share this link with your friends, family or colleagues
            </p>
            <div className="flex flex-col sm:flex-row items-center" data-id="element-604">
              <div className="w-full sm:flex-1 bg-gray-100 rounded-t-md sm:rounded-l-md sm:rounded-tr-none p-3 text-sm truncate break-all" data-id="element-605">
                {shareUrl}
              </div>
              <button onClick={handleCopyLink} className="w-full sm:w-auto bg-[#E84118] text-white py-3 px-4 rounded-b-md sm:rounded-r-md sm:rounded-bl-none hover:bg-[#d13a16] transition-colors" data-id="element-606">
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
          <div className="flex justify-center space-x-4 mb-6 sm:mb-8" data-id="element-607">
            <button className="flex flex-col items-center p-3 bg-green-50 rounded-md" data-id="element-608">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-full flex items-center justify-center mb-2" data-id="element-609">
                <svg viewBox="0 0 24 24" className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="currentColor" data-id="element-610">
                  <path d="M17.498 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.101-.473-.15-.673.15-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.174-.3-.019-.465.13-.615.136-.135.301-.345.451-.523.146-.181.194-.301.297-.496.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.172-.015-.371-.015-.571-.015-.2 0-.523.074-.797.359-.273.3-1.045 1.02-1.045 2.475s1.07 2.865 1.219 3.075c.149.195 2.105 3.195 5.1 4.485.714.3 1.27.48 1.704.629.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z" data-id="element-611" />
                  <path d="M20.52 3.449a12.826 12.826 0 00-3.644-2.374l-.144-.072a.75.75 0 00-.631 1.359l.1.046a11.32 11.32 0 013.214 2.096c.855.712 1.587 1.528 2.193 2.437.595.908 1.018 1.887 1.302 2.921.284 1.018.433 2.076.433 3.141a12.254 12.254 0 01-3.57 8.611 12.317 12.317 0 01-2.385 1.935c-.876.571-1.814 1-2.806 1.312-1.003.286-2.043.429-3.083.429s-2.08-.143-3.083-.435a11.985 11.985 0 01-2.806-1.312 12.342 12.342 0 01-2.385-1.935c-.998-1.01-1.813-2.161-2.415-3.449-.6-1.288-.9-2.65-.9-4.006 0-1.065.149-2.123.433-3.141.284-1.034.707-2.013 1.302-2.92.595-.909 1.327-1.726 2.193-2.437.866-.712 1.82-1.283 2.84-1.712a.75.75 0 00-.326-1.431 12.575 12.575 0 00-3.233 1.977c-.997.822-1.832 1.76-2.498 2.786-.666 1.025-1.146 2.129-1.491 3.298-.338 1.157-.507 2.348-.507 3.562 0 1.577.343 3.112 1.008 4.554.663 1.442 1.599 2.729 2.735 3.825a13.885 13.885 0 002.707 2.175c.98.633 2.039 1.128 3.16 1.47 1.13.329 2.307.493 3.489.493 1.181 0 2.358-.164 3.489-.493 1.121-.342 2.18-.837 3.16-1.47.99-.634 1.885-1.343 2.707-2.175 1.136-1.096 2.072-2.383 2.735-3.825.665-1.442 1.008-2.977 1.008-4.554 0-1.213-.17-2.404-.507-3.562-.345-1.169-.825-2.273-1.491-3.298-.666-1.026-1.501-1.964-2.498-2.786z" data-id="element-612" />
                </svg>
              </div>
              <span className="text-xs sm:text-sm" data-id="element-613">WhatsApp</span>
            </button>
            <button className="flex flex-col items-center p-3 bg-blue-50 rounded-md" data-id="element-614">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-full flex items-center justify-center mb-2" data-id="element-615">
                <svg viewBox="0 0 24 24" className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="currentColor" data-id="element-616">
                  <path d="M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 01-1.75 1.75H1.75A1.75 1.75 0 010 18.75v-14C0 3.784.784 3 1.75 3zM1.5 7.412V18.75c0 .138.112.25.25.25h20.5a.25.25 0 00.25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0L1.5 7.412zM22.25 5H1.75a.25.25 0 00-.25.25v.342l10.36 6.993a.25.25 0 00.28 0l10.36-6.993V5.25a.25.25 0 00-.25-.25z" data-id="element-617" />
                </svg>
              </div>
              <span className="text-xs sm:text-sm" data-id="element-618">Email</span>
            </button>
          </div>
        </div>
        {/* Participants list */}
        <div className="mb-6 sm:mb-8" data-id="element-619">
          <div className="flex items-center mb-3 sm:mb-4" data-id="element-620">
            <UsersIcon size={18} className="text-gray-500 mr-2" data-id="element-621" />
            <h2 className="font-medium" data-id="element-622">
              Participants ({participants.length})
            </h2>
          </div>
          <div className="border rounded-md divide-y" data-id="element-623">
            {participants.map(participant => <div key={participant.id} className="p-3 flex items-center" data-id="element-624">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-3" data-id="element-625">
                  {participant.name.charAt(0)}
                </div>
                <span className="text-sm sm:text-base" data-id="element-626">{participant.name}</span>
              </div>)}
          </div>
        </div>
        <Button onClick={handleContinue} fullWidth size="lg" data-id="element-627">
          Continue to Food Selection
        </Button>
      </div>
    </div>;
};
export default GroupOrderShare;